import styled from 'styled-components'
import Typography from '../Typography'

export default styled(Typography).attrs({ as: 'h3' })`
  margin-bottom: 28px;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-bottom: ${({ theme }) => theme.spacing.km10};
  }
`
